'use client';

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import type { TotemWithLocation } from '@/app/(users)/totem-by-slug/[slug]/actions/get-totem-with-location';
import { getTotemWithLocation } from '@/app/(users)/totem-by-slug/[slug]/actions/get-totem-with-location';
import { supabase } from '@/lib/supabase/client';

export function useTotemContext(totemId: string) {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey: ['totems', totemId, 'context'],
    queryFn: () => getTotemWithLocation({ totemId }),
  });

  useEffect(() => {
    if (!totemId) return;

    const channel = supabase
      .channel(`totem-version:${totemId}`)
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'totems',
          filter: `id=eq.${totemId}`,
        },
        () => {
          queryClient.invalidateQueries({ queryKey: ['totems', totemId, 'context'] });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [totemId, queryClient]);

  return {
    totem: data as TotemWithLocation | null | undefined,
    isLoading,
    error,
  };
}
